import { h } from "preact";
import { useEffect } from "preact/hooks";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchTasks,
  selectCurrentUser,
  selectIsLoggedIn,
  setLoading,
  startTask,
} from "../store";

import LinearLoadingIndicator from "../components/LinearLoadingIndicator.jsx";
import TaskModalHeader from "../components/TaskModalHeader.jsx";
import TaskModule from "../components/TaskModule.jsx";
import NotFoundPage from "./NotFoundPage.jsx";
import TaskModuleIntro from "../components/TaskModuleIntro.jsx";

export default function TaskPage() {
  const { taskId } = useParams();
  const task = useSelector((state) =>
    state.tasks.items.find((task) => task.id === taskId)
  );
  const loading = useSelector((state) => state.ui.loading);
  const currentUser = useSelector(selectCurrentUser);
  const isLoggedIn = useSelector(selectIsLoggedIn);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  async function handleStartClick() {
    await dispatch(startTask(task));
  }

  useEffect(async () => {
    dispatch(setLoading(true));
    await dispatch(fetchTasks());
    dispatch(setLoading(false));
  }, []);

  if (!task) {
    if (isLoggedIn) {
      return <NotFoundPage />;
    } else {
      location.href = `/login?redirect_to=/app/tasks/${encodeURIComponent(
        taskId
      )}`;
      return;
    }
  }

  return (
    <div class="task-modal">
      <TaskModalHeader sticky task={task} />
      <div class="task-modal__content">
        {loading && <LinearLoadingIndicator class="task-modal__loading" />}
        {task.started ? (
          <TaskModule task={task} onClose={() => navigate("/tasks")} />
        ) : (
          <TaskModuleIntro
            task={task}
            user={currentUser}
            onStart={handleStartClick}
          />
        )}
      </div>
    </div>
  );
}
